module.exports = __webpack_public_path__ + "static/media/DeliveryWhite.58591927.svg";